<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <CashbackProgramCreateAndUpdateFormItems :form="form" :data="cashbackProgram" />
    </VForm>
</template>
<script>
import { rootActions, Getters } from '@/store/types'
import VForm from '@/components/VForm.vue'
import CashbackProgramCreateAndUpdateFormItems from '@/components/CashbackProgramCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        CashbackProgramCreateAndUpdateFormItems,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        cashbackProgram () {
            return this.$store.getters[Getters.cashback.GET_CASHBACK_PROGRAM](this.id)
        },
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.UPDATE_CASHBACK_PROGRAM, { id: this.id, ...values },
            )
            return res
        },
    },
}
</script>
